    <!-- Usuario -->
    <ng-container *ngIf="userData.rol === 'ADMINISTRADOR DE CONTRATOS'">
        <app-dashboard-user></app-dashboard-user>
    </ng-container>
    
    <!-- Admin -->
    <ng-container *ngIf="userData.rol === 'NEGOCIADOR/CATEGORY'">
        <app-dashboard-admin></app-dashboard-admin>
    </ng-container>
